<template>
  <div style="background: #eaeaea">
    <div style="">
      <img
        v-if="advertisements.filter((a) => a.category.id == 9).length > 0"
        :src="advertisements.filter((a) => a.category.id == 9)[0].picture"
        style="width: 100%; height: 350px"
        @click="
          handleAdvertisementClick(
            advertisements.filter((a) => a.category.id == 9)[0]
          )
        "
      />
      <img
        v-else
        src="../assets/images/Information.png"
        style="width: 100%; height: 350px"
      />
    </div>
    <div class="content">
      <div
        class="content-item"
        v-for="(item, index) in articleList"
        :key="index"
      >
        <div style="position: relative">
          <img
            style="width: 514px; height: 118px"
            :src="item.properties.picture || '../assets/images/industry.png'"
          />
          <p class="content-item-title">{{ item.name }}</p>
        </div>
        <div class="characters">
          <p
            v-for="(article, i) in item.articles"
            :key="i"
            @click="handleArticleClick(article)"
          >
            {{ article.name }}
          </p>
        </div>
        <div class="industry_onsultancy">
          <el-divider class="divider">
            <router-link
              class="view_more"
              :to="`/viewsmore?categoryId=${item.id}`"
              :style="$i18n.locale == 'zh' ? '' : 'padding:13px 33px'"
            >
              {{ $t("All Information") }}</router-link
            >
          </el-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ArticleService from "../services/article";
import { getArticleBanners, getArticles } from "../http/api";
import { request } from "../http/http";

export default {
  data() {
    return {
      advertisements: [],
      articleList: [],
    };
  },
  computed: {
    ...mapState({
      articleCategories: (state) => state.articleCategories,
    }),
  },
  watch: {
    articleCategories: {
      handler() {
        this.queryData();
      },
      immediate: true,
    },
  },
  methods: {
    async handleAdvertisementClick(advertisement) {
      console.log(advertisement);

      if (advertisement.type == "BANNER" && advertisement.link) {
        window.open(advertisement.link);
      }
    },
    handleArticleClick(article) {
      switch (article.linkType) {
        case "LINK":
          window.open(article.link);
          break;
        case "EXTERNAL_LINK":
          window.open(article.linkContent);
          break;
        default:
          this.$router.push({
            path: `/article/${article.id}`,
          });
          break;
      }
    },
    async getAdvertisements() {
      this.advertisements = await getArticleBanners();
    },
    async queryData() {
      const articleList = [];

      for (const articleCategory of this.articleCategories) {
        const result = await getArticles({
          categoryId: articleCategory.id,
          page: 0,
          size: 5,
        });
        articleList.push({
          ...articleCategory,
          articles: result.content,
        });
      }
      this.articleList = articleList;
    },
    async init() {
      this.getAdvertisements();

      this.articleList = this.articleCategories;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 30px;
}

.content-item {
  width: 585px;
  height: 468px;
  background-color: #ffffff;
  border: 1px solid #dddddd;
  margin-top: 30px;
  box-sizing: border-box;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 33px 33px 20px 33px;
}
.divider {
  width: 514px;
  height: 1px;
  background: #619a37;
  // margin: 0;
}

.view_more {
  background: #619a37;
  color: #fff;
  padding: 13px 67px;
}

.industry_onsultancy {
}
.title .introduction {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
.characters {
  width: 100%;
  align-self: flex-start;
  justify-content: flex-start;
  flex: 1;
}
.characters p {
  text-align: left;
  border-bottom: 1px dashed #666666;
  padding: 14px 0;
  width: 514px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
  &:last-child {
    border-bottom: none;
  }
}
.content-item-title {
  font-size: 24px !important;
  font-weight: 500;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/article.vue